import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-acad-canvas px-4 py-20 sm:py-28" data-id="element-213" data-mp="3fzntdk80p90u">
      <div className="mx-auto max-w-6xl" data-id="element-214" data-mp="3fxuly2pkykrs">
        <div className="text-center" data-id="element-215" data-mp="3b0udxm9677y1">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-acad-gold" data-id="element-216" data-mp="3azt57ofmmxjh">
            Teacher feedback
          </p>
          <h2 className="mt-3 font-display text-4xl font-semibold text-acad-ink sm:text-5xl" data-id="element-217" data-mp="36wwgrh3eo77m">
            What Tap Dance Instructors Are Saying
          </h2>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-218" data-mp="2x1l2t0ztn40x">
          {testimonials.map((testimonial, index) => <motion.figure key={testimonial.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.28,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex h-full flex-col rounded-2xl border border-acad-line bg-white p-7 shadow-card" data-id="element-219" data-mp="2s3jf22rgagj4" data-mpi={index}>
              <QuoteIcon size={42} className="absolute right-6 top-5 text-acad-goldSoft" aria-hidden="true" data-id="element-220" data-mp="zwpr05qo4du5" />
              <blockquote className="relative text-sm font-medium leading-6 text-acad-muted" data-id="element-221" data-mp="14xlu4h373vyi">
                “{testimonial.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-8" data-id="element-222" data-mp="v4o6xxn9ditk">
                <span className="h-11 w-11 shrink-0 rounded-full border border-acad-gold/50 bg-acad-goldSoft" data-id="element-223" data-mp="1ius71v18n0ft" />
                <span data-id="element-224" data-mp="1nn25jzgf58tp">
                  <strong className="block text-sm text-acad-ink" data-id="element-225" data-mp="1nnla8eh260ps">
                    {testimonial.attribution}
                  </strong>
                  <span className="block text-xs text-acad-muted" data-id="element-226" data-mp="1siwdqiikhw7s">
                    {testimonial.location}
                  </span>
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}